import DataPerpus from '../../views/Library/DataPerpus.view';

export default DataPerpus;